export default __webpack_public_path__ + "static/media/save.5f11287c.svg";